module.exports = __webpack_public_path__ + "img/1 dia.a62c69af.jpg";